//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '@/mixins'
import upDialog from './components/Dialog.vue'
import testDialog from './components/testDialog.vue'
import { MainApi } from '@/api'
import Util from '@/common/js/util'
// import  from '@/api'
export default {
  name: 'riskTest',
  mixins: [mixin],
  components: {
    upDialog,
    testDialog,
  },
  data() {
    return {
      showsArr: {
        el0: false,
        el1: true,
        el2: true,
        el3: true,
        el4: true,
        el5: true,
      },
      scoreArr: {
        score0: null,
        score1: null,
        score2: null,
        score3: null,
        score4: null,
        score5: null,
      },
      nextText: '下一题',
      prevText: '返回',
      askArr: [
        {
          title: '您认为理财产品的实际收益？',
          arr: [
            {
              name: '不会低于公布预期收益',
              score: 0,
            },
            {
              name: '就是公布的预期收益',
              score: 1,
            },
            {
              name: '一定高于存款',
              score: 2,
            },
            {
              name: '一定不会为0',
              score: 3,
            },
            {
              name: '可能为0或负',
              score: 4,
            },
          ],
        },
        {
          title: '您认为理财产品的本金可能会损失?',
          arr: [
            {
              name: '不会损失',
              score: 0,
            },
            {
              name: '10%之内，基本都是保本',
              score: 1,
            },
            {
              name: '20%之内，都是低风险',
              score: 2,
            },
            {
              name: '不一定，可能超过20%',
              score: 3,
            },
            // {
            //   name: '可能为0或负',
            //   score: 4,
            // },
          ],
        },
        {
          title: '是否会支取您的已存款项？',
          arr: [
            {
              name: '不会支取',
              score: 0,
            },
            {
              name: '随时可能支取',
              score: 1,
            },
          ],
        },
        {
          title: '您期望的投资理财回报为：',
          arr: [
            {
              name: '跟银行利率相同',
              score: 0,
            },
            {
              name: '比定期存款利率高',
              score: 1,
            },
            {
              name: '远超定期存款利率',
              score: 2,
            },
          ],
        },
        {
          title: '以下哪项描述最符合您的投资态度：',
          arr: [
            {
              name: '厌恶风险，不希望本金损失，并希望有稳定回报',
              score: 0,
            },
            {
              name: '保守投资，不希望本金损失，可承担小幅度收益波动',
              score: 1,
            },
            {
              name: '寻求资金的较高收益，可承担有限本金损失',
              score: 2,
            },
            {
              name: '希望赚取高回报，愿意为此承担较大本金损失',
              score: 3,
            },
          ],
        },
        {
          title: '您可能选择的投资组合是：',
          arr: [
            {
              name: '固定收益4%',
              score: 0,
            },
            {
              name: '最大收益5%，最大损失0%',
              score: 1,
            },
            {
              name: '最大收益15%，最大损失5%',
              score: 2,
            },
            {
              name: '最大收益20%，最大损失8%',
              score: 3,
            },
            {
              name: '最大收益42%，最大损失24%',
              score: 4,
            },
          ],
        },
      ],
      nowNum: 0,
      isCanClick: true,
      isRuleShows: false,
      isSkipShows: false,
      isTestResShows: false,
      overTag: '',
      id: '',
      isminH: true,
      // tagArr: ['谨慎型', '稳健型', '平衡型', '进取型', '激进型'],
    }
  },
  created() {
    this.id = this.$route.query.id
    this.setStyleFn()
  },
  mounted() {},
  watch: {
    nowNum() {
      this.prevText = this.nowNum === 0 ? '返回' : '上一题'
      this.nextText =
        this.nowNum === this.askArr.length - 1 ? '获取报告' : '下一题'
    },
  },
  methods: {
    topBackFn() {
      if (this.getArchives) {
        this.backHomeFn()
      } else {
        this.skipFn()
      }
    },
    setStyleFn() {
      var domW = document.documentElement.clientWidth
      var domH = document.documentElement.clientHeight

      var domMinusH = parseInt((360 / domW) * domH)

      if (domMinusH - 360 < 225) {
        this.isminH = false
      }
    },
    backHomeFn() {
      this.$router.push('myPlan')
    },
    prevFn() {
      if (this.isCanClick) {
        // if (this.scoreArr['score' + this.nowNum] === null) {
        //   this.$vux.toast.show({
        //     type: 'warn',
        //     text: '请选择你的答案',
        //   })
        //   return false
        // }

        if (this.nowNum === 0) {
          this.backHomeFn()
          return false
        }
        this.showsArr['el' + this.nowNum] = true
        this.nowNum--
        this.showsArr['el' + this.nowNum] = false
        this.isCanClick = false
        let timer = setTimeout(() => {
          this.isCanClick = true
          clearTimeout(timer)
        }, 800)
      }
    },
    nextFn() {
      if (this.isCanClick) {
        if (this.scoreArr['score' + this.nowNum] === null) {
          this.$vux.toast.show({
            type: 'warn',
            text: '请选择你的答案',
          })
          return false
        }

        if (this.nowNum === this.askArr.length - 1) {
          //console.log('答题结束')
          this.getChangeSkipFn()
          return false
        }
        this.showsArr['el' + this.nowNum] = true
        this.nowNum++
        this.showsArr['el' + this.nowNum] = false
        this.isCanClick = false
        let timer = setTimeout(() => {
          this.isCanClick = true
          clearTimeout(timer)
        }, 800)
      }
    },
    selectAnswerFn(idx, key) {
      this.scoreArr['score' + idx] = key
      // if (this.nowNum === this.askArr.length - 1) {
      //   return false
      // }
      let timer = setTimeout(() => {
        this.nextFn()
        clearTimeout(timer)
      }, 300)
      // //console.log('选了题', this.scoreArr)
    },
    getChangeCloseFn() {
      this.isRuleShows = false
    },
    getChangeSkipCloseFn() {
      this.isSkipShows = false
    },
    skipFn() {
      this.isSkipShows = true
    },
    lookRuleFn() {
      this.isRuleShows = true
    },
    getChangeSkipFn() {
      let overScore = 0
      for (let val of Object.values(this.scoreArr)) {
        overScore += val
      }
      let tagNum = this.scoreToTagFn(overScore)
      this.overTag = Util.getTagArrFn()[tagNum - 1]
      this.$vux.loading.show({
        text: '加载中',
      })
      MainApi.updataRiskAssessment({ Type: tagNum })
        .then(data => {
          this.$vux.loading.hide()
          if (data.Status === 200) {
            //console.log('data')
            // if (this.id) {
            this.isSkipShows = false
            this.isTestResShows = true

            this.$store.commit('editStateFn', {
              field: 'Archives',
              val: tagNum,
            })
            localStorage.setItem('Archives', tagNum)

            // } else {
            //   this.$router.push('addPlan')
            // }
          } else {
            this.$vux.toast.text(data.Result.ErrorMsg, 'top')
          }
        })
        .catch(() => {
          this.$vux.loading.hide()
        })
    },
    scoreToTagFn(score) {
      if (score <= 3) {
        return 1
      } else if (score >= 4 && score <= 9) {
        return 2
      } else if (score >= 10 && score <= 12) {
        return 3
      } else if (score >= 13 && score <= 15) {
        return 4
      } else if (score >= 16) {
        return 5
      }

      // if (score <= 3) {
      //   return '谨慎型'
      // } else if (score >= 4 && score <= 9) {
      //   return '稳健型'
      // } else if (score >= 10 && score <= 12) {
      //   return '平衡型'
      // } else if (score >= 13 && score <= 15) {
      //   return '进取型'
      // } else if (score >= 16) {
      //   return '激进型'
      // }
    },
  },
  computed: {
    getArchives() {
      return this.$store.state.Archives
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/riskTest.vue